import { kebabCase } from 'lodash';
import { DataAttributes } from './pickDataAttributes';

interface DataAttributeContext {
  id?: number | string;
  type?: string;
}

interface DataObject {
  'data-object-id'?: string;
  'data-object-type'?: string;
}

/**
 * Generate the following data attributes
 * ( data-object-id, data-object-type, data-[dynamic attribute name from optionalAttributes] )
 * Use on element: {...dataAttribsForEl(context, { someAttribueKey: someAttributeValue })}
 *
 * @param {DataAttributeContext} context The object containing the id and type
 * @param {object | undefined} optionalAttributes Optional object of attributes
 * { attributeName: attributeValue }
 * example: { action: 'some-action' } becomes data-action="some-action"
 * works with single word, camel, or kebab
 * @returns {DataAttributes} Object with all properties that contain `data-`
 */
export const dataAttribsForEl = (
  context: DataAttributeContext = { id: '', type: '' },
  optionalAttributes?: object
): DataAttributes => {
  const dataObject: Record<string, unknown> = { 'data-object-id': context.id, 'data-object-type': context.type };
  if (optionalAttributes) {
    Object.entries(optionalAttributes).map(([key, value]: [string, string]) => {
      dataObject[`data-${kebabCase(key)}`] = kebabCase(value);
    });
  }
  return dataObject;
};

type DataAttribsForElParamsTuple = Parameters<typeof dataAttribsForEl>;

export type DataAttribsForElParams = {
  context?: DataAttribsForElParamsTuple[0];
  optionalAttributes?: DataAttribsForElParamsTuple[1];
};
